import { generatePath } from '@cibo/core'
import {
  LandReportMapInteractive,
  LandReportMapDataLayerPicker,
  useLandReportView,
} from '@cibo/landmanager'
import { ActionBar } from '@cibo/ui'
import { Button, Stack } from '@mui/material'
import { LayoutSection } from 'components/ImpactLayout'
import { LAND_MANAGER_ROUTES } from 'navigation/types/routes'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

export const FieldMapPage = () => {
  const { t } = useTranslation('pages/LandManager/FieldMap')
  const { resourceId } = useParams()
  const { field, dataLayer, setDataLayer } = useLandReportView({ resourceId })

  return (
    <>
      <LayoutSection flex={1} sx={{ padding: 0 }} autoHeight>
        <LandReportMapInteractive
          dataLayer={dataLayer}
          setDataLayer={setDataLayer}
          field={field.data}
          mapPadding={6}
        />
      </LayoutSection>
      <ActionBar>
        <Stack direction="row" justifyContent="space-between" flexWrap="wrap">
          <LandReportMapDataLayerPicker
            dataLayer={dataLayer}
            setDataLayer={setDataLayer}
            size="small"
          />
          <Button
            component={Link}
            to={generatePath(LAND_MANAGER_ROUTES.DETAIL, {
              resourceId,
            })}
            variant="contained"
          >
            {t('back')}
          </Button>
        </Stack>
      </ActionBar>
    </>
  )
}
